export default __webpack_public_path__ + "static/media/logo.881676e2.png";